import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/case-studies/page.tsx");
